import { ReactNode } from 'react';

type ColorPickerCompProps = {
  children?: ReactNode;
};

export const ColorPickerComp = ({ children }: ColorPickerCompProps) => {
  return (
    <div className={`border-gray border-solid border-0 border-b flex items-center justify-center flex-wrap p-2`}>
      {children}
    </div>
  );
};
